module.exports = __webpack_public_path__ + "static/img/diamond.6061ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranks/diamond.png
// module id = RQ0Y
// module chunks = 1